import $ from 'jquery'
$(document).on('keyup', $('#coupon_code, .input_coupon_code'), function() {
    const $coupon_input = $('#coupon_code, .input_coupon_code')
    const $button = $('button[name="apply_coupon"]')
    let empty_box = $coupon_input.val()
    if (empty_box !== "") {
        $button.addClass('solid-coupon-button')
    } else {
        $button.removeClass('solid-coupon-button')
    }
})

$('.coupon-form input[name="coupon_code"]').on( 'input change', function(){
    $('form.checkout_coupon input[name="coupon_code"]').val($(this).val());
});

$('.coupon-form input[name="coupon_code"]').on( 'keypress', function(event){
    let keycode = (event.keyCode ? event.keyCode : event.which);
    if(keycode == '13'){
        event.preventDefault();
        $('.coupon-form button[name="apply_coupon"]').click()
    }
});

$('.coupon-form button[name="apply_coupon"]').on( 'click', function(){
    $('form.checkout_coupon').submit();
});